import { Component, OnInit,ViewChild } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { menulist } from '../class/status';
import { ToastComponent } from "../../layout/toast/toast.component";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';


@Component({
    selector: 'app-syssetting',
    templateUrl: './syssetting.component.html',
    styleUrls: ['./syssetting.component.css']
})

export class SyssettingComponent implements OnInit {
    @ViewChild(ToastComponent, { static: true }) toastComponent: ToastComponent;
    loading:boolean=true;
    now:string='0';
    menu_list:menulist = [{id:'0',name:'角色設定'},{id:'1',name:'設定'}];
    edit_data:any={
        role:[],menuTotal:[],menudialy:[],menuiv:''
    };
    edit_role:any={
        name:'',status:1
    };
    menu_name:any[];
    edit_component:any=[];
    role_id:Number = 0;
    role_menu:any=[];
    toggleValue:true;
    
    componentpower: string[] = [];

    selectedOptions: string[] = [];
    selectedMenuValue: string[] = [];
  
    roleComponent:string[] = [];
    finalOrder: string[] = [];
    finalOrdersub: string[] = [];
    
    submainNum:Number = 0;
    subMenu:any[];

    texteria:any=[];

    constructor(public httpClient: HttpClient,) {
   
    }

    mainMenu:any=[];

    restart(){
        const body = {act: 8 };
        this.httpClient.post<any>("/customer_service/component_setting.php",body).subscribe(res => {
            this.loading = false;
            if(res.data['status']){
                this.toastComponent.showMessage('還原成功', 'success');
                this.add_component(3);
            }
        }, error => {
            console.log(error);
        }); 
    }

    submain(id){
        const body = {act: 7 , id:id };
        this.httpClient.post<any>("/customer_service/component_setting.php",body).subscribe(res => {
            this.loading = false;
            if(res.data['status']){
               this.subMenu = res.data.subData;
            }
        }, error => {
            console.log(error);
        }); 



        this.submainNum = id;
    }
    
    drop(event: CdkDragDrop<string[]>) {
 
        moveItemInArray(this.mainMenu, event.previousIndex, event.currentIndex);
        this.finalOrder = [...this.mainMenu];

        const body = {act: 6 , finalOrder:this.finalOrder };
        this.httpClient.post<any>("/customer_service/component_setting.php",body).subscribe(res => {
            this.loading = false;
            if(res.data['status']){
                this.toastComponent.showMessage('修改成功', 'success');
            }
        }, error => {
            console.log(error);
        }); 


    }

    dropsub(event: CdkDragDrop<string[]>) {
 
        moveItemInArray(this.subMenu, event.previousIndex, event.currentIndex);
        this.finalOrdersub = [...this.subMenu];

        const body = {act: 6 , finalOrder:this.finalOrdersub };
        this.httpClient.post<any>("/customer_service/component_setting.php",body).subscribe(res => {
            this.loading = false;
            if(res.data['status']){
                this.toastComponent.showMessage('修改成功', 'success');
            }
        }, error => {
            console.log(error);
        }); 


    }

    ngOnInit(): void {        
        this.init_list();  
    }

    changeComponentPower(){
        const body = {act: 3 , selectedMenuValue:this.selectedMenuValue , selectedRole:this.selectedOptions,componentpower:this.componentpower,texteria:this.texteria};
        this.httpClient.post<any>("/customer_service/component_setting.php",body).subscribe(res => {
            this.loading = false;
            if(res.data['status']){
                this.toastComponent.showMessage('修改成功', 'success');
            }
            this.init_list();  
        }, error => {
            console.log(error);
        }); 
        
    }

    changeMenuPower(id:Number){        
        const body = {act: 5 , role_menu:this.role_menu , id:id};
        this.httpClient.post<any>("/customer_service/menu_list_setting.php",body).subscribe(res => {
            this.loading = false;
            if(res.data['status']){
                this.toastComponent.showMessage('修改成功', 'success');
            }
            this.init_list();  
        }, error => {
            console.log(error);
        }); 
    }

    defaultData(){
        this.edit_role = { name:'',status:1};    
    }

    allchange(data){
        if(data.uid == 0){
            const updatedData = this.role_menu.map(item => {
                if (item.uid == data.id) {
                    item.status = data.status;
                }
                return item;
            });
        }
    }

    addRole(){
        this.loading = true;
        if(this.edit_role.name == ''){
            alert('名稱必填');
        }else{
            const body = {act: 3, edit_role:this.edit_role};
            this.httpClient.post<any>("/customer_service/menu_list_setting.php",body).subscribe(res => {
                this.loading = false;
                if(res.data['status']){
                    this.toastComponent.showMessage('新增成功', 'success');
                }
                this.init_list();  
            }, error => {
                console.log(error);
            }); 
        }       
    }

    cancelMenu(n,i): void {

        let targetObject = this.edit_data.menudialy.find(obj => obj.hasOwnProperty(i));
        
        if (targetObject && targetObject[i]) {
          targetObject[i].splice(n, 1);
        }
    }

    init_list(){
        this.loading = true;
        //act 1 (get)
        const body = {act: 1 };
        this.httpClient.post<any>("/customer_service/menu_list_setting.php",body).subscribe(res => {
            this.loading = false;
            this.edit_data.role = res.data.role;
        }, error => {
            console.log(error);
        });
    }

    getRoleMenu(id:Number){
        this.loading = true;
        this.role_menu = [];
        this.role_id = 0;
        const body = {act: 4,id:id };
        this.httpClient.post<any>("/customer_service/menu_list_setting.php",body).subscribe(res => {
            this.loading = false;
            this.role_menu = JSON.parse(res.data['menu']);
            this.role_id = id;
        }, error => {
            console.log(error);
        });
    }


    add_component(act:Number){
        
        let body = {};
        
        switch (act) {
            case 1:
                body = {act:1};
                this.httpClient.post<any>("/customer_service/component_setting.php",body).subscribe(res => {
                    if(res.data['status']){
                        this.menu_name = res.data['permission'];
                        this.componentpower = res.data['adminpermission'];
                        this.selectedMenuValue = res.data['Menu_id'];
                        this.selectedOptions = res.data['Role_id'];
                        this.texteria = res.data['texteria'];
                    }
                }, error => {
                    console.log(error);
                });
            break;
            case 2:
                body = {act:2};
                this.httpClient.post<any>("/customer_service/component_setting.php",body).subscribe(res => {
                    if(res.data['status']){
                        this.toastComponent.showMessage('新增成功', 'success');
                        this.add_component(1);
                    }
                }, error => {
                    console.log(error);
                });
            break;
            case 3:
                body = {act:5};
                this.httpClient.post<any>("/customer_service/component_setting.php",body).subscribe(res => {
                    if(res.data['status']){
                        this.mainMenu = res.data.mainData;
                        console.log(res.data.mainData);

                    }
                }, error => {
                    console.log(error);
                });
            break;
            default:
            break;
        }
    }

    getRoleComponent(id:Number){
        this.role_id = id;
        const body = {id:id,act:4};
        this.httpClient.post<any>("/customer_service/component_setting.php",body).subscribe(res => {
            if(res.data['status']){
                this.roleComponent = res.data['roleComponent'];
            }
        }, error => {
            console.log(error);
        });
    }

    choose(now){
        this.now = now;
        switch (now) {
            case '0':
                this.init_list();
                break;
            case '1':
                this.add_component(3);
                break;
            default:
                break;
        }
    }

    handleStatusChange(newStatus: any) {
        this.loading = true;
        const body = {newStatus,act:newStatus.act};
        this.httpClient.post<any>("/customer_service/menu_list_setting.php",body).subscribe(res => {
            if(res.data['status']){
                this.toastComponent.showMessage('更新成功', 'success');
            }
            this.init_list();  
            this.loading = false;
        }, error => {
            console.log(error);
        });
    }
  
}
